import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { CtxAlertComponent, CtxButtonComponent, CtxForm } from 'ng-ui';
import { ResourceUpdateFormData } from 'utils';

@Component({
  selector: 'ctx-google-sso-form',
  standalone: true,
  imports: [
    MatDialogModule,
    MatInputModule,
    CtxAlertComponent,
    CtxButtonComponent,
  ],
  templateUrl: './google-sso-form.component.html',
})
export class GoogleSsoFormComponent extends CtxForm implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<GoogleSsoFormComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: ResourceUpdateFormData,
    private fb: FormBuilder
  ) {
    super();
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({});
  }

  /** True if Google SSO is currently enabled. */
  get isSsoEnabled(): boolean {
    return this.dialogData.resource.googleSsoEnabled;
  }

  get formValue() {
    return {
      googleSsoEnabled: !this.dialogData.resource.googleSsoEnabled,
    };
  }
}
